import { ECrudType } from 'redux/actions/crud';
import { EActions } from 'redux/actions/EActions';
import { GetReducer } from './crud';

const reducer = GetReducer(
  ECrudType.rates,
  (obj: any) => {
    return {
      ...obj,
    };
  },
  undefined,
  (state: any, action: any) => {
    switch (action.type) {
      case ECrudType.rates + '_' + EActions.CRUD_BEGIN_EDIT:
        return {
          ...state,
          showModal: true,
          obj: { rateType: 'Hourly', ...action.payload },
          isNew: action.payload === undefined,
        };
    }
  },
);

export default reducer;
